export function RequestsFilterChip(props: {
  chipId: string;
  label: string;
  count: number | undefined;
  active: boolean;
  onClick: () => void;
}) {
  // WHY: `aria-pressed` is the only signal of selection state available
  // to assistive tech in the multi-select chip model — color/style alone
  // does not convey active/inactive to screen readers.
  return (
    <button
      type="button"
      data-testid={`requests-chip-${props.chipId}`}
      onClick={props.onClick}
      aria-pressed={props.active}
      style={{
        height: 26,
        padding: '0 10px',
        borderRadius: 'var(--r-1)',
        fontSize: 12,
        fontWeight: 500,
        border: '1px solid',
        borderColor: props.active ? 'transparent' : 'var(--border-1)',
        background: props.active ? 'var(--accent-1-subtle)' : 'var(--bg-1)',
        color: props.active ? 'var(--accent-1-press)' : 'var(--fg-2)',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        cursor: 'pointer',
      }}
    >
      <span>{props.label}</span>
      {props.count !== undefined && (
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 10,
            color: props.active ? 'var(--accent-1-press)' : 'var(--fg-3)',
          }}
        >
          {props.count}
        </span>
      )}
    </button>
  );
}
